<template>
  <div>
    <b-row>
      <b-col xl="12">
        <b-card no-header>
          <b-alert
            class="alert"
            :show="dismissCountDown"
            dismissible
            fade
            :variant="alertVariant"
            @dismissed="dismissCountDown = 0"
            @dismiss-count-down="countDownChanged">
            <p>{{ alertMsj }}</p>
          </b-alert>

          <b-form>
            <b-form-group
              label="Fecha Crédito"
              label-for="fechaCreditoDebito"
              :labelCols="labelCols"
              horizontal>
              <b-form-input 
                id="fechaCreditoDebito" 
                v-model="fechaCreditoDebito" 
                type="date">
              </b-form-input>
            </b-form-group>

            <app-banco-cuenta
              label="Cuenta"
              :nombre="bancoCuentaNombre"
              :lista="bancosCuentasList"
              :labelCols="labelCols"
              :valido="bancoCuentaValida"
              :msjInvalido="bancoCuentaInvalidaMsj"
              @updated="bancoCuentaActualizada">
            </app-banco-cuenta>

            <b-form-group
              label="Importe"
              label-for="importe"
              :labelCols="labelCols"
              horizontal>
              <b-form-input 
                id="importe"
                v-model.trim="$v.importe.$model" 
                :state="importeValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="importeFeedback">
                {{ importeInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>
          </b-form>
          <div slot="footer">
            <b-button size="sm" variant="primary" class="footer-button"
              @click.prevent="save">Grabar</b-button>
            <b-button size="sm" variant="danger" class="footer-button"
              @click.prevent="goBack">Cancelar</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import BancoCuenta from '../shared/abmSelect.vue';
import { required, requiredIf, numeric, decimal, maxLength, minValue } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'transferencia/getField',
  mutationType: 'transferencia/updateField',
});

export default {
  name: 'ABM',
  /*
  props: {
    cliente: {
      type: Object,
      default: null
    }
  },
  */
  components: {
    appBancoCuenta: BancoCuenta,
  },
  props: {
    cuentasPesos: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      noValidar: true,
      bancoCuentaValida: null,
      bancoCuentaInvalidaMsj: '',
      importeValido: null,
      importeInvalidoMsj: '',

      bancosCuentas: [],
      bancosCuentasList: [],

      labelCols: 2,
      alertCountDown: 10, 
      dismissCountDown: 0,
      alertVariant: 'danger',
      alertMsj: ''
    }
  },
  computed: {
    ...mapFields([
      'id',
      'fechaCreditoDebito',
      'bancoCuenta',
      'bancoCuentaNombre',
      'importe',
    ])
  },  
  created() {
    this.$store.dispatch('transferencia/inicializar')
      .then(() => this.getDatosAdicionales())
      .catch(error => {
        this.alertMsj = error;
        this.alertVariant = "danger";
        this.alertCountDown = 15;
        this.showAlert();
      });
  },  
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert() {
      this.dismissCountDown = this.alertCountDown;
    },
    getDatosAdicionales() {
      const vm = this

      let params = {};
      
      if (this.cuentasPesos) {
        params.monedaId = 101;
      }

      vm.$store.dispatch('bancoscuentas/getList', params)
        .then(() => {
          vm.bancosCuentas = this.$store.getters['bancoscuentas/list'];
          vm.bancosCuentasList = this.$store.getters['bancoscuentas/selectList'];
        })
        .catch(() => {
          this.alertMsj = "Se produjo un error al recuperar la lista de cuentas.";
          this.alertVariant = "danger";
          this.alertCountDown = 15;
          this.showAlert();
        });
    },
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar)
          {
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'importe' || validarTodos) {
        if (this.$v.importe.$error) {
          this.importeValido = false;
          if (!this.$v.importe.decimal) {
            this.importeInvalidoMsj = 'El importe de la transferencia debe ser un valor numérico';
          } else if (!this.$v.importe.minValue) {
              this.importeInvalidoMsj = 'El importe de la transferencia no es válido';
          }     
        } else {
          this.importeValido = null;
          this.importeInvalidoMsj = '';
        }
      }
    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      this.$v.$touch();

      let save = true;

      let bancoCuentaError = true;
      if (this.bancoCuenta) {
        if (this.bancoCuenta.id) {
          if (this.bancoCuenta.id != 0) {
            bancoCuentaError = Boolean(false);
          }
        }
      }
      if (bancoCuentaError) {
        save = false;
        this.bancoCuentaValida = false;
        this.bancoCuentaInvalidaMsj = 'Debe seleccionar la cuenta correspondiente.';
      }

      if (save) {
        if (this.$v.$anyError) {
          this.displayErrores();
        } else {
          this.$emit('transferenciaAgregada', 
            this.$store.getters['transferencia/transferencia']);
        } 
      }
    },
    bancoCuentaActualizada(nombre) {
      this.bancoCuentaNombre = nombre;

      let bancoCuenta;
      if (this.bancoCuentaNombre) {
        bancoCuenta = this.getSelected(this.bancosCuentas, this.bancoCuentaNombre);
      }
      this.$store.dispatch('transferencia/setBancoCuenta', bancoCuenta);

      this.bancoCuentaValida = null;
      this.bancoCuentaInvalidaMsj = '';
    },
    goBack() {
      this.$emit('cancel');
    }
  },
  watch: {
  },
  validations: {
    importe: {
      decimal,
      minValue: minValue(0)
    },
  },  
}
</script>

<style>
</style>
